import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import {
  PageHeader,
  ExpTreeTableWithButtons,
  Section,
  DangerousWrapper,
  clip,
  stripHTML
} from '@budget-monorepo/shared-ui';

import Layout from '../components/Layout';
import HelmetData from '../components/HelmetData';

const NonTaxRevenue = (props) => {
  const { data } = props;
  const { content, site } = data;
  // eslint-disable-next-line camelcase
  const { modifiedTime, mg_mod_date, mg_mod_datetime } = content.parent;
  const layoutProps = {
    activeIndex: 2,
    above: () => <PageHeader title={content.title} category={content.budgetSection} />,
    pageTitle: content.title,
    dataTimeStamp: modifiedTime,
    buildTimeStamp: site.buildTime
  };
  const expandableTreeTableWithButtonsProps = {
    defaultExpLevel: 0,
    expTreeTableProps: {
      table: content.revenueBySourceFundTotalTable,
      data: content.revenueBySourceFundTotalTable.data,
      pivotBy: ['programArea', 'governmentArea'],
      aggregateBy: ['unrestrictedNonTaxRevenue', 'restrictedNonTaxRevenue', 'totalNonTaxRevenue'],
      subIndex: 3
    },
    treeTableButtonsProps: {
      a11yTitle: content.revenueBySourceFundTotalTable.title,
      buttons: [{
        info: 'View by revenue sources grouped by government area.',
        text: 'View by government area',
        expLevel: 0,
        accessor: 'programArea'
      }, {
        info: 'View the revenue sources.',
        text: 'View by revenue source',
        expLevel: 1,
        accessor: 'governmentArea'
      }]
    }
  };
  // metadata for the page
  const metaTitle = `${content.budgetSection}: ${content.title}`;
  const metaDescription = clip(stripHTML(content.summary), 160);
  return(
    <Fragment>
      <HelmetData {...{
        metaTitle,
        metaDescription,
        mg_mod_date,
        mg_mod_datetime
      }}
      />
      <Layout {...layoutProps}>
        <Section>
          <DangerousWrapper rawHtml={content.summary} />
          <h3>{content.revenueBySourceFundTotalTable.title}</h3>
          <ExpTreeTableWithButtons {...expandableTreeTableWithButtonsProps} />
        </Section>
      </Layout>
    </Fragment>
  );
};

NonTaxRevenue.propTypes = {
  data: PropTypes.object
};

export default NonTaxRevenue;

export const query = graphql`
  query nonTaxRevenueJson {

    site {
      ...SiteMetadata
    }
    content: pagesJson(fields: {slug: {eq: "/section-1b/"}}) {
      title
      budgetSection
      summary
      revenueBySourceFundTotalTable {
        title
        headers {
          name
          type
          align
          value
        }
        total {
          programArea
          governmentArea
          revenueDetail
          unrestrictedNonTaxRevenue
          restrictedNonTaxRevenue
          totalNonTaxRevenue
        }
        data {
          programArea
          governmentArea
          revenueDetail
          unrestrictedNonTaxRevenue
          restrictedNonTaxRevenue
          totalNonTaxRevenue
          rowType
        }
      }
      # Get the last modified timestamp for the file powering the page
      ...PagesJsonDataTimeStamp
    }
  }
`;
